import { TRowComponentProps } from '@libs/types';
import React, { MouseEventHandler } from 'react';
import { RowEnum } from '../../../types/enums';
import { SelectorRegular } from './SelectorRegular';
import { SelectorExtraView } from './SelectorExtraView';

export type TRowComponent = {
    handleClick: MouseEventHandler<HTMLButtonElement>;
} & TRowComponentProps;

const RowComponent: React.FC<TRowComponent> = ({ handleClick, ...props }) => {
    const { value, isSelected, ...rest } = props;

    switch (props.id) {
        case RowEnum.ROW_REGULAR:
            return <SelectorRegular isWidget={false} value={!!isSelected} handleClick={handleClick} {...rest} />;
        case RowEnum.SELECTOR_REGULAR:
            return <SelectorExtraView handleClick={handleClick} isSelected={isSelected} {...rest} />;
        default:
            return <SelectorRegular isWidget={false} value={!!isSelected} handleClick={handleClick} {...rest} />;
    }
};

export default RowComponent;
